// Helper function to convert form row to structured backend format
export function convertRowToStructuredFormat(row: any[]): any[] {
  return [
    {
      type: "col",
      unit: "time",
      value: (() => {
        const timeValue = row[0];
        if (typeof timeValue === "string" && timeValue.trim() !== "") {
          return { time: timeValue, type: "LT" };
        } else if (typeof timeValue === "object" && timeValue?.time) {
          return {
            time: timeValue.time || "",
            type: timeValue.type || "LT",
          };
        } else {
          return { time: "", type: "LT" };
        }
      })(),
    },
    {
      type: "col",
      unit: "userref",
      value: (() => {
        const userValue = row[1];
        if (typeof userValue === "object" && userValue?.userid) {
          const firstname =
            userValue.firstname ||
            (userValue.full_name ? userValue.full_name.split(" ")[0] : "");
          const surname =
            userValue.surname ||
            (userValue.full_name
              ? userValue.full_name.split(" ")[1] || ""
              : "");

          return {
            userid: userValue.userid || null,
            firstname: firstname,
            surname: surname,
            rolename: userValue.rolename || "",
          };
        } else {
          return {
            userid: null,
            firstname: "",
            surname: "",
            rolename: "",
          };
        }
      })(),
    },
    {
      type: "col",
      unit: "large/text",
      value: typeof row[2] === "string" ? row[2] : "",
    },
  ];
}

// Helper function to convert multiple rows to structured format
function convertRowsToStructuredFormat(rows: any[]): any[] {
  return rows
    .filter((row: any) => Array.isArray(row))
    .map((row: any) => convertRowToStructuredFormat(row));
}

export function deepMapTimeToString(entry: any) {
  if (!entry?.sections) return entry;
  const mappedSections = entry.sections.map((sec: any) => {
    if (!sec?.rows) return sec;
    const structuredRows = convertRowsToStructuredFormat(sec.rows);

    return {
      ...sec,
      rows: structuredRows,
    };
  });
  return { ...entry, sections: mappedSections };
}

export function convertBackendToFormFormat(entry: any) {
  if (!entry?.sections) return entry;
  const mappedSections = entry.sections.map((sec: any) => {
    if (!sec?.rows) return sec;

    const formRows = sec.rows
      .filter((row: any) => Array.isArray(row))
      .map((row: any) => {
        return row.map((col: any) => {
          if (col?.type === "col" && col?.value !== undefined) {
            return col.value;
          }
          return col;
        });
      });

    return {
      ...sec,
      rows: formRows,
    };
  });
  return { ...entry, sections: mappedSections };
}
